export default function RSVP() {
  return (
    <div className="bg-secondary rounded-[50px] p-4 md:p-8 max-w-[525px] mx-4 md:mx-auto relative">
      <div className="bg-linen rounded-[25px] flex flex-col items-center justify-center px-0 pb-6">
        <div className="w-full mx-auto h-[250px] md:h-[300px] overflow-hidden relative">
          <img src="/hopeToSeeYouThere.png" alt="Hope to see you there" className="absolute inset-0 w-full h-full object-cover scale-[1.15]" />
        </div>
      </div>
    </div>
  );
}